import React, { SVGProps } from 'react';

const NoDataIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={44}
    height={44}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="NoDataIcon">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.917 43.083H10.083a3.667 3.667 0 0 1-3.666-3.666V4.583A3.667 3.667 0 0 1 10.083.917H27.5c.293 0 .544.147.711.362l9.01 9.01a.9.9 0 0 1 .362.711v28.417a3.667 3.667 0 0 1-3.666 3.666Zm-5.5-39.067v6.067h6.067l-6.067-6.067Zm7.333 7.9H27.5a.916.916 0 0 1-.917-.916V2.75h-16.5A1.834 1.834 0 0 0 8.25 4.583v34.834c0 1.012.821 1.833 1.833 1.833h23.834a1.834 1.834 0 0 0 1.833-1.833v-27.5Zm-5.5 23.834h-16.5a.916.916 0 1 1 0-1.833h16.5a.916.916 0 1 1 0 1.833Zm0-7.333h-16.5a.916.916 0 1 1 0-1.834h16.5a.916.916 0 1 1 0 1.834Zm-8.324-7.334H13.75a.916.916 0 1 1 0-1.833h8.176a.916.916 0 1 1 0 1.833Z"
      fill="var(--secondaryText)"
    />
    <rect
      x={32.109}
      y={32.108}
      width={11.892}
      height={11.892}
      rx={5.946}
      fill="#F66"
    />
    <path
      d="m40.035 36.072-3.964 3.964M36.071 36.072l3.964 3.964"
      stroke="#191A1F"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NoDataIcon;
